import { Field, Type, IExtractor, LinkExtractor, ImageExtractor, TextExtractor } from './selector'

export class Paginator {
 selector = '';
 attr = '';
 type = '';
 pageNum = 10;
}

export class Request {
 url = '';
 userToken = '';
 type = '';
 actions = Array<any>();
 proxy = '';
}

export class Collection {
	paginator = '';
	paginatorUI: Paginator = null;
	paginatedResults = false;
	format = '';
	path = false;
	namePattern = new RegExp('https?://(?:www\.)?([^\.]+\.[a-zA-Z]{2,})', 'g');
	selectorNamePattern = RegExp('selector(\\d+)');
	preview = true;
	constructor(public name: string, public request: Request, public fields: Array<Field>) {
	}

	deleteSelector(id: number) {
		this.fields.splice(id, 1);
	}

	updateSelection(selectorId: number, obj: any) {
		let property = 'selector';
		let t: Type = Type.Text;
		let attrs: Array<string>;
		if (obj.data.data.type === 'a') {
			attrs = new Array<string>('href', 'text');
			// property = 'link';
			t = Type.Link;
		} else if (obj.data.data.type === 'img') {
			attrs = new Array<string>('src', 'alt');
			// property = 'image';
			t = Type.Image;
		} else {
			attrs = new Array<string>('text');
		}
		if (this.fields[selectorId].selector.length === 0) {
			let property_index = 1;
			let maxIndex = 1;
			for (let i = 0; i < this.fields.length; i++) {
				if (this.fields[i].name.indexOf(property) !== -1) {
					let index = this.fields[i].name.match(this.selectorNamePattern);
					if (index !== null && +index[1] === property_index) {
						property_index = maxIndex = maxIndex + 1;
					} else {
						if (index !== null && maxIndex < +index[1]) {
							maxIndex = +index[1];
						}
					}
				}
			}
			if (this.fields[selectorId].name === 'Click on element to select it') {
				property += property_index;
			}
			let newSelector = new Field(property, obj.data.data.current_selected, null, obj.data.data.count);
			newSelector.type = t;
			newSelector.attrs = attrs;
			this.fields[selectorId] = newSelector;

		} else {
			this.fields[selectorId].selector = obj.data.data.current_selected;
			this.fields[selectorId].count = obj.data.data.count;
			if (this.fields[selectorId].type !== t) {
				this.fields[selectorId].type = t;
				this.fields[selectorId].attrs = attrs;
				this.fields[selectorId].details = null;
			}
		}
	}

	updateName() {
		return this.namePattern.exec(this.request.url)[1];
	}

	isValid() {
		return this.name !== undefined && this.name.length > 0 && this.fields !== undefined
		 && this.fields.length > 0 && this.request !== undefined && this.request.url !== undefined &&  this.request.url.length > 0;
	}

	stringify(format, collectionName): string {
		this.name = collectionName;
		this.format = format;
		return JSON.stringify(this, this.filter);
	}

	filter(i, val) {
		if (i === 'fieldMapValue' || /* i === 'attrs' || */
			i === 'mask' || i === 'count' ||
			i === 'namePattern' || (i === 'details' && val === null) ||
			(i === 'paginator' && val === '') /* || i === 'type' */ ||
			i === 'paginatedResults' || i === 'param' && val === '' ||
			(i === 'paginatorUI') || i === 'selectorNamePattern' || i === 'preview' || i === 'userToken'
			|| val === '' || val === []) {
			return undefined;
		}
		if (i === 'paginator' && this.paginatorUI !== null) {
			return {'nextPageSelector': this.paginatorUI.selector , 'pageNum': this.paginatorUI.pageNum };
		}
		return val;
	}

	isContainsDetails(): boolean {
		for (let i = 0; i < this.fields.length; i++) {
			if (this.fields[i].details != null) {
				return true;
			}
		}
		return false;
	}
}
